export default "__VITE_ASSET__BY9sLxEF__"